import React from 'react';
import { useAuth } from './AuthContext';
import ParticlesBackground from './ParticlesBackground';
import AppNavbar from './Navbar';
import './Momentum.css';

const SectorResearch = () => {
    const { isAuthenticated, loading, error, setError, login } = useAuth();
    const [localEmail, setLocalEmail] = React.useState('');
    const [iframeHeight, setIframeHeight] = React.useState(800);
    const API_URL = process.env.REACT_APP_API_URL || '';

    React.useEffect(() => {
        const handler = (e) => {
            if (e.data && e.data.type === 'iframeHeight' && e.data.height > 100) {
                setIframeHeight(e.data.height + 24);
            }
        };
        window.addEventListener('message', handler);
        return () => window.removeEventListener('message', handler);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        await login(localEmail);
    };

    if (loading) {
        return (
            <div className="momentum-page">
                <header className="momentum-header">
                    <AppNavbar />
                    <ParticlesBackground />
                    <div className="header-content"><h1>Sector Research</h1></div>
                </header>
                <main className="momentum-main">
                    <div className="container"><p>Loading...</p></div>
                </main>
            </div>
        );
    }

    if (!isAuthenticated) {
        return (
            <div className="momentum-page">
                <header className="momentum-header">
                    <AppNavbar />
                    <ParticlesBackground />
                    <div className="header-content"><h1>Sector Research</h1></div>
                </header>
                <main className="momentum-main">
                    <div className="container">
                        <div className="auth-section">
                            <h2>Subscriber Access Required</h2>
                            <p>Enter your Substack email to access sector research.</p>
                            <form onSubmit={handleSubmit}>
                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    value={localEmail}
                                    onChange={(e) => setLocalEmail(e.target.value)}
                                    required
                                />
                                <button type="submit">Login</button>
                            </form>
                            {error && <p className="error-message">{error}</p>}
                            <iframe
                                src="https://machinaquanta.substack.com/embed"
                                title="Substack Subscription"
                                width="480"
                                height="320"
                                frameBorder="0"
                                scrolling="no"
                            />
                        </div>
                    </div>
                </main>
                <footer className="models-footer">
                    <div className="container">
                        <p>&copy; 2023-{new Date().getFullYear()} machinaquanta.com. All rights reserved.</p>
                    </div>
                </footer>
            </div>
        );
    }

    return (
        <div className="momentum-page">
            <header className="momentum-header">
                <AppNavbar />
                <ParticlesBackground />
                <div className="header-content">
                    <h1>Sector Research</h1>
                </div>
            </header>

            <main className="momentum-main" style={{ padding: '12px 0 0 0' }}>
                <div className="container">
                    <iframe
                        src={`${API_URL}/data/sector-research`}
                        title="Sector Research"
                        style={{
                            width: '100%',
                            height: `${iframeHeight}px`,
                            border: 'none',
                            borderRadius: '4px',
                        }}
                    />
                </div>
            </main>

            <footer className="models-footer">
                <div className="container">
                    <p>&copy; 2023-{new Date().getFullYear()} machinaquanta.com. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default SectorResearch;
